exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1Hxg2{width:100%;margin-left:auto;margin-right:auto;overflow:hidden}._1Hxg2,._2IXKP{max-width:1080px}._2IXKP{margin:0 auto}._1Qoms{margin-bottom:12px}.RO4Rc{margin-bottom:48px}._1SLKj{margin-top:18px}._3dgmL{margin-top:24px}.LFs5V{margin-top:12px}a{font-size:14px;line-height:1.43}a,a:active,a:focus,a:hover{color:#149ce9;text-decoration:none}.FGYnH{position:relative;height:auto}._2vO7y{list-style:none;margin:0;padding:0;-webkit-backface-visibility:hidden;backface-visibility:hidden;position:relative;display:inline-block;vertical-align:bottom;overflow:hidden;background-color:#fafafa}._14wGT{border-radius:50%;border:2px solid #fff}._3RPsf{width:100%;height:auto;object-fit:cover}._2OzrS{border-radius:0;width:100%;display:block;color:#585858;font-size:16px;padding-bottom:12px;border-bottom:1px solid #d9d9d9}._1xiHV{font-size:24px;line-height:1;font-weight:400;font-style:normal;color:#6e6f71;display:block}._3ipHn{margin-bottom:18px}._5P1ay{padding-left:0;list-style:none;font-size:14px;line-height:1.43;color:#585858}._1DHws{font-size:44px;font-weight:400;margin-top:0;margin-bottom:15px;line-height:1.1;color:#585858}._2q_yV{font-weight:700;font-family:Helvetica;line-height:1.1;color:#a4a7a9}._2l2YN,._2q_yV{font-size:16px;margin-top:12px}._2l2YN{line-height:1.43}._2l2YN,._2l2YN:hover{color:#6e6f71;cursor:pointer}._2l2YN:hover{text-decoration:underline}._1Jqwm{font-size:25px;line-height:1;font-weight:400;font-style:normal;color:#6e6f71;padding-right:5px}._35cC_{text-align:center}._1ymv3{float:none;display:table-cell;vertical-align:middle}.uqjNQ{display:none}._1xEmP,._3BuxY{float:right}._5rekS{float:left}._3saYV{height:16px;width:16px;vertical-align:text-bottom}._2prAl{display:table}._2prAl,._2rIMl{position:relative}._2rIMl{-webkit-backface-visibility:hidden;backface-visibility:hidden;display:inline-block;overflow:hidden;background-color:#fafafa;border-radius:50%;border:2px solid #fff}._2h0Xt{position:relative}.v6wOy,.WBafe{color:#6e6f71}.WBafe{position:relative;z-index:1;display:block;margin:15px 1px;width:100%;text-align:center;font-size:14px}.Gk0eE{padding-left:5px}._2xmWG,.Gk0eE{display:table-cell}._17aiH{font-weight:700;font-family:Helvetica}._17tp5{max-width:74px;word-wrap:break-word}._3vOZ6>div:last-child .r7Sv3{opacity:0;height:0}._3Mlq8{padding:7px 21px;border-color:#c4c4c4;background:#fff;color:#585858;font-weight:700;font-family:Helvetica;font-size:14px;border-radius:0;cursor:pointer}.Keu48{border-color:#35baef;background-color:#35baef;color:#fff;font-family:inherit}._1VkJZ{padding:9px 27px}.Keu48:active,.Keu48:active:focus,.Keu48:active:hover,.Keu48:focus,.Keu48:hover{border-color:#35baef;background-color:#35baef;color:#fff}.mzOpL,.mzOpL:active,.mzOpL:active:focus,.mzOpL:active:hover,.mzOpL:focus,.mzOpL:hover{border-color:#35baef;color:#35baef;background-color:#fff}._3nUdO{border-radius:0}._3guAQ{border-radius:4px;padding:9px 21px}@media screen and (max-width:640px){.uqjNQ{display:block}._29E_6{display:none}._17tp5{width:100%;max-width:100%}._2prAl{display:block}._1xEmP,._2prAl{text-align:center}._1xEmP,._5rekS{float:none}._1SKh1{padding:0}}.DzkHO{background:transparent!important}", ""]);

// exports
exports.locals = {
	"pageContainer": "_1Hxg2",
	"containerResponsive": "_2IXKP",
	"space2": "_1Qoms",
	"space3": "_3ipHn",
	"space4": "RO4Rc",
	"spaceTop3": "_1SLKj",
	"spaceTop4": "_3dgmL",
	"spaceTop2": "LFs5V",
	"slideShow": "FGYnH",
	"slideShowImages": "_2vO7y",
	"mediaRound": "_14wGT",
	"imgResponsive": "_3RPsf",
	"panelHeader": "_2OzrS",
	"circleIcon": "_1xiHV",
	"listStyle": "_5P1ay",
	"profileTitle": "_1DHws",
	"profileInfo": "_2q_yV",
	"reportProfile": "_2l2YN",
	"flagIcon": "_1Jqwm",
	"textCenter": "_35cC_",
	"colMiddle": "_1ymv3",
	"showSm": "uqjNQ",
	"avatarWrapper": "_1xEmP",
	"pullRight": "_3BuxY",
	"pullLeft": "_5rekS",
	"homeIcon": "_3saYV",
	"mediaContainer": "_2prAl",
	"profileAvatarLink": "_2rIMl",
	"avatarDisplay": "_2xmWG",
	"commentContainer": "_2h0Xt",
	"reviewMuted": "v6wOy",
	"horizontalLineThrough": "WBafe",
	"reviewBody": "Gk0eE",
	"textBold": "_17aiH",
	"profileName": "_17tp5",
	"recommendations": "_3vOZ6",
	"lineSeperation": "r7Sv3",
	"btn": "_3Mlq8",
	"btnPrimary": "Keu48",
	"btnlarge": "_1VkJZ",
	"btnPrimaryBorder": "mzOpL",
	"btnRadius": "_3nUdO",
	"linkBtn": "_3guAQ",
	"hideSm": "_29E_6",
	"smPadding": "_1SKh1",
	"noBackground": "DzkHO"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/components/ViewProfile/ViewProfile.css
// module id = 2582
// module chunks = 15